import face1 from "assets/images/face-male-1.jpg";
import face3 from "assets/images/face-male-2.jpg";
import face5 from "assets/images/face-male-3.jpg";
import face7 from "assets/images/face-male-4.jpg";

import face2 from "assets/images/face-female-1.jpg";
import face4 from "assets/images/face-female-2.jpg";
import face6 from "assets/images/face-female-3.jpg";
import face8 from "assets/images/face-female-4.jpg";

export default [
  {
    id: 1,
    avatar: face1,
    name: "李铭浩",
  },
  {
    id: 2,
    avatar: face2,
    name: "孙文佳",
  },
  {
    id: 3,
    avatar: face3,
    name: "慕容天宇",
  },
  {
    id: 4,
    avatar: face4,
    name: "郭文菲",
  },
  {
    id: 5,
    avatar: face5,
    name: "张峰",
  },
  {
    id: 6,
    avatar: face6,
    name: "李凝",
  },
  {
    id: 7,
    avatar: face7,
    name: "王雨斐",
  },
  {
    id: 8,
    avatar: face8,
    name: "赵子枫",
  },
];
